import { useState } from 'react';

import { Loader } from 'components/Loader';
import { CreateConsumptionVariationPopup } from './Popups/CreateConsumptionVariationPopup';
import { ConsumptionVariationDetails } from './ConsumptionVariationDetails';
import { ColumnsSectionContainer, SectionColumn, SectionContainer } from 'components/DetailsView/Section';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { useGetSiteConsumptionVariationsQuery } from 'data/__generated__';

export const ConsumptionVariations = ({ siteId }: { siteId: string }) => {
    const [isCreateConsumptionVariationPopupOpen, setIsCreateConsumptionVariationPopupOpen] = useState<boolean>(false);

    const {
        loading: consumptionVariationsLoading,
        data: consumptionVariationsData,
        error: consumptionVariationsError,
    } = useGetSiteConsumptionVariationsQuery({ variables: { siteId } });

    if (consumptionVariationsLoading && !consumptionVariationsData) {
        return (
            <SectionContainer title="Variation de la consommation" isInitiallyOpen={false}>
                <Loader />
            </SectionContainer>
        );
    }

    if (consumptionVariationsError || !consumptionVariationsData) {
        throw new Error('Une erreur est survenue lors de la récupération des variations de consommation');
    }

    const { siteConsumptionVariations } = consumptionVariationsData;

    const sortedConsumptionVariations = [...siteConsumptionVariations]
        .sort((consumptionVariationA, consumptionVariationB) =>
            consumptionVariationB.endDate.localeCompare(consumptionVariationA.endDate),
        )
        .sort((consumptionVariationA, consumptionVariationB) =>
            consumptionVariationB.startDate.localeCompare(consumptionVariationA.startDate),
        );

    return (
        <>
            <SectionContainer title="Variation de la consommation" isInitiallyOpen={false}>
                <ColumnsSectionContainer numberOfColumns={1}>
                    <SectionColumn>
                        <TotemPrimaryButton
                            onClick={(e) => {
                                e.preventDefault();
                                setIsCreateConsumptionVariationPopupOpen(true);
                            }}
                        >
                            Ajouter une variation de la consommation
                        </TotemPrimaryButton>
                        {sortedConsumptionVariations.map((consumptionVariation) => (
                            <ConsumptionVariationDetails
                                key={consumptionVariation._id}
                                consumptionVariation={consumptionVariation}
                            />
                        ))}
                    </SectionColumn>
                </ColumnsSectionContainer>
            </SectionContainer>

            <CreateConsumptionVariationPopup
                siteId={siteId}
                isOpen={isCreateConsumptionVariationPopupOpen}
                setIsOpen={setIsCreateConsumptionVariationPopupOpen}
            />
        </>
    );
};
